import React, { useState } from 'react'
import {
  Icon,
  Button,
  Card,
  Form,
  Radio,
  Row,
  Col,
  Table,
  Select,
  Checkbox
} from 'antd'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import { PODType } from '../../config'

import _ from 'lodash'
import {
  fetchPoDeliverList,
  updatePODStatus
} from '../../modules/heroGroupSelling'
import HeroPODView from '../HeroPODView'
import UpdateStatus from './UpdateStatus'
import styled from 'styled-components'

const HeroPOD = ({ form, data }) => {
  const dispatch = useDispatch()
  const { validateFields, getFieldDecorator } = form
  const [filterOptions, setFilterOptions] = useState({})
  const [visible, setVisible] = useState(false)
  const [visibleStatus, setVisibleStatus] = useState(false)
  const [formData, setFormData] = useState({})
  const [poDeliverId, setPoDeliverId] = useState(0)
  const [checkedList, setCheckedList] = useState([]) // เก็บรายการที่ถูกเลือก
  const [checkAll, setCheckAll] = useState(false)

  const { poDeliverList, isLoading } = useSelector(
    (state) => ({
      poDeliverList: state.heroGroupSelling.poDeliverList,
      isLoading: state.heroGroupSelling.isLoading
    }),
    []
  )
  async function fetch() {
    await dispatch(fetchPoDeliverList(filterOptions))
  }

  useDeepEffect(() => {
    form.setFieldsValue({
      status: []
    })
    setCheckAll(false)
    setCheckedList([])
    fetch()
  }, [])

  const columns = [
    {
      title: 'วันที่ส่ง',
      dataIndex: 'sendDate',
      key: 'sendDate',
      render: (date) => (
        <span>{date ? moment(date).format('DD/MM/YYYY') : '-'}</span>
      )
    },
    {
      title: 'วัสดุที่ส่ง',
      dataIndex: 'heroPoResponse.materialName',
      key: 'materialName',
      render: (materialName) => <span>{materialName}</span>
    },
    {
      title: 'ผู้ส่ง',
      key: 'heroSentName',
      dataIndex: 'heroDeliver.name',
      render: (heroName) => <span>{heroName}</span>
    },
    {
      title: 'ส่ง',
      key: 'amountSent',
      dataIndex: 'amountSent',
      render: (amountSent) => <span>{amountSent ? amountSent : ''}</span>
    },
    {
      title: 'ผู้รับ',
      key: 'heroReceiveName',
      dataIndex: 'heroPoResponse.heroName',
      render: (heroName) => <span>{heroName}</span>
    },
    {
      title: 'รับ',
      key: 'amountReceive',
      dataIndex: 'amountReceive',
      render: (amountReceive) => (
        <span>{amountReceive ? amountReceive : ''}</span>
      )
    },
    {
      title: 'สถานะ',
      key: 'status',
      dataIndex: 'status',
      render: (name, record) => {
        return (
          <div>
            {PODType[name] ? (
              <a onClick={(e) => onClickStatus(e, record)}>
                {PODType[name].title} &nbsp; <Icon type="edit" />
              </a>
            ) : (
              name
            )}
          </div>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="eye"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
        </span>
      )
    }
  ]
  const onClear = async (e) => {
    e.preventDefault()
    setFilterOptions((prevState) => {
      prevState.status = undefined
      return prevState
    })

    form.setFieldsValue({
      status: []
    })
    setCheckAll(false)
    setCheckedList([])
    await dispatch(fetchPoDeliverList(filterOptions))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const isAllChecked = checkedList.includes('ALL')
    if (isAllChecked) {
      filterOptions.status = undefined
    } else {
      const joinCheckedList = checkedList.join(',')
      filterOptions.status = joinCheckedList
    }
    setFilterOptions(filterOptions)
    console.log(filterOptions)
    await dispatch(fetchPoDeliverList(filterOptions))
    // validateFields(async (err, values) => {
    //   if (!err) {
    //     if (values.status) {
    //       if (values.status == "All") {
    //         filterOptions.status = undefined
    //       } else {
    //         filterOptions.status = checkedList
    //       }
    //     }
    //     setFilterOptions(filterOptions)
    //     console.log(filterOptions)
    //     // await dispatch(fetchPoDeliverList(filterOptions))
    //   }
    // })
  }

  const onChangeCheckbox = (checkedList) => {
    setCheckedList(checkedList) // อัปเดตรายการที่ถูกเลือก
    if (checkedList[0] === 'ALL')
      setCheckAll(checkedList.length === 1 && checkedList[0] === 'ALL') // ตรวจสอบสถานะของ Checkbox ทั้งหมด
  }

  const onCheckAllChange = (e) => {
    console.log(e.target.checked)
    setCheckedList(e.target.checked ? [] : checkedList) // อัปเดตรายการที่ถูกเลือก
    setCheckAll(e.target.checked) // ตั้งค่าสถานะของ Checkbox ทั้งหมด
  }

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setPoDeliverId(record.id)
  }

  const onCloseModal = async () => {
    await setVisible(false)
  }

  const onClickStatus = (e, record) => {
    e.preventDefault()
    setFormData(record)
    setVisibleStatus(true)
  }

  const onCloseModalStatus = async () => {
    await setVisibleStatus(false)
    await fetch()
  }

  const onOkStatus = async (data) => {
    await dispatch(updatePODStatus(data))
    await fetch()
    await setVisibleStatus(false)
    await setFormData({})
  }

  const radioStyle = {
    marginRight: '8px',
    marginBottom: '8px'
  }

  const checkboxStyle = {
    marginRight: '8px',
    marginBottom: '8px'
  }

  const options = [
    // กำหนด options ในตัวแปรภายในคอมโพเนนต์
    {
      label: 'จองส่งสินค้า / รอยืนยันรับสินค้า',
      value: 'ON_RESERVE,CONFIRM_PENDING'
    },
    { label: 'รอจัดส่ง', value: 'RESERVE_ACTIVE,CONFIRM_SENT' },
    { label: 'จัดส่ง / รับสินค้า', value: 'ON_DELIVERY' },
    { label: 'ยืนยันน้ำหนักรับ', value: 'ARRIVE_CHECK' },
    { label: 'ส่ง / รอเอกสาร', value: 'ARRIVE_PASS' },
    { label: 'รอโอน / เช็คโอน', value: 'INVOICE_SEND' },
    { label: 'ยืนยัน / รอยืนยันรับเงิน', value: 'CASH_DELIVER' },
    { label: 'เสร็จสิ้น', value: 'DONE' },
    {
      label: 'ยกเลิก',
      value: 'CONFIRM_CANCEL,CANCEL_RESERVE,CANCEL_SELLER,CANCEL_BUYER'
    }
    // เพิ่ม options อื่นๆ ตามต้องการ
  ]

  const CheckboxWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-left: 0px;
    gap: 4px;
  `

  const StyledCheckbox = styled(Checkbox)`
    margin-right: 8px; // Keep consistent horizontal spacing
    margin-bottom: 4px; // Keep consistent vertical spacing
    margin-left: 8px; // Apply consistent left margin to all checkboxes
  `

  return (
    <div>
      {!visible ? (
        <Card title="รายการส่ง (POD)">
          <Row type="flex" gutter={[8, 8]}>
            <Col span={24}>
              <Form
                form={form}
                layout="vertical"
                colon={false}
                onSubmit={handleSubmit}>
                <Row gutter={8}>
                  <Col span={18}>
                    <Row gutter={8}>
                      <Col>
                        <Form.Item label="สถานะ">
                          {getFieldDecorator('status', {
                            initialValue: []
                          })(
                            <div style={{ marginBottom: 4 }}>
                              <Checkbox.Group
                                value={checkedList}
                                onChange={onChangeCheckbox}>
                                <CheckboxWrapper>
                                  <StyledCheckbox
                                    onChange={onCheckAllChange}
                                    checked={checkAll}
                                    style={{ marginLeft: 8 }}
                                    value="ALL">
                                    ทั้งหมด
                                  </StyledCheckbox>

                                  {options.map((option, index) => (
                                    <StyledCheckbox
                                      key={index}
                                      value={option.value}
                                      disabled={checkAll}>
                                      {option.label}
                                    </StyledCheckbox>
                                    // <Checkbox
                                    //   value={option.value}
                                    //   disabled={checkAll}>
                                    //   {option.label}
                                    // </Checkbox>
                                  ))}
                                </CheckboxWrapper>
                              </Checkbox.Group>
                            </div>
                          )}
                        </Form.Item>

                        {/* <Form.Item label="สถานะ">
                          {getFieldDecorator('status')(
                            <div style={{ marginBottom: 4 }}>
                              <Radio.Group>
                                <Radio.Button style={radioStyle} value="All">ทั้งหมด</Radio.Button>
                                <Radio.Button style={radioStyle} value="ON_RESERVE,CONFIRM_PENDING">จองส่งสินค้า / รอยืนยันรับสินค้า</Radio.Button>
                                <Radio.Button style={radioStyle} value="RESERVE_ACTIVE,CONFIRM_SENT">รอจัดส่ง</Radio.Button>
                                <Radio.Button style={radioStyle} value="ON_DELIVERY">จัดส่ง / รับสินค้า</Radio.Button>
                                <Radio.Button style={radioStyle} value="ARRIVE_CHECK">ยืนยันน้ำหนักรับ</Radio.Button>
                                <Radio.Button style={radioStyle} value="ARRIVE_PASS">ส่ง / รอเอกสาร</Radio.Button>
                                <Radio.Button style={radioStyle} value="INVOICE_SEND">รอโอน / เช็คโอน</Radio.Button>
                                <Radio.Button style={radioStyle} value="CASH_DELIVER">ยืนยัน / รอยืนยันรับเงิน</Radio.Button>
                                <Radio.Button style={radioStyle} value="DONE">เสร็จสิ้น</Radio.Button>
                                <Radio.Button style={radioStyle} value="CONFIRM_CANCEL,CANCEL_RESERVE,CANCEL_SELLER,CANCEL_BUYER">ยกเลิก</Radio.Button>
                              </Radio.Group>
                            </div>
                          )}
                        </Form.Item> */}
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="" style={{ marginTop: '1.75rem' }}>
                      <Row gutter={8} type="flex">
                        <Col>
                          <Button type="primary" htmlType="submit">
                            ค้นหา
                          </Button>
                        </Col>
                        <Col>
                          <Button type="danger" onClick={(e) => onClear(e)}>
                            เคลียร์
                          </Button>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
            <Col span={24}>
              <Table
                loading={isLoading}
                bordered
                dataSource={poDeliverList}
                columns={columns}
                rowKey={(record) => {
                  return record.id
                }}
              />
              <UpdateStatus
                visible={visibleStatus}
                onOk={onOkStatus}
                onCancel={onCloseModalStatus}
                formData={formData}
              />
            </Col>
          </Row>
        </Card>
      ) : (
        <HeroPODView
          visible={visible}
          poDeliverId={poDeliverId}
          onCancel={onCloseModal}
        />
      )}
    </div>
  )
}

const WrappedHeroPOD = Form.create({
  name: 'WrappedHeroPOD'
})(HeroPOD)

export default WrappedHeroPOD
